module.exports = __webpack_public_path__ + "img/part-2-title.d38c7bdb.png";